// extracted by mini-css-extract-plugin
export var dropdown = "dropdown-module--dropdown--oOQZk";
export var dropdownList = "dropdown-module--dropdown-list--fg-fF";
export var footerDropdown = "dropdown-module--footer-dropdown--+5HZZ";
export var isOpen = "dropdown-module--isOpen--r7vdo";
export var listItem = "dropdown-module--list-item--FhgtU";
export var listItemDescription = "dropdown-module--list-item-description--YKrY4";